"use client";

import { useRef, useEffect } from "react";

import useConstantRefCallback from "./useConstantRefCallback";

const useValueListener = <Value = unknown>({
	onChange,
	value,
}: {
	onChange: (args: { previous: Value; value: Value }) => void;
	value: Value;
}) => {
	const onChangeRef = useConstantRefCallback(onChange);
	const previousRef = useRef(value);

	useEffect(() => {
		const { current: previous } = previousRef;
		if (value !== previous) {
			onChangeRef({ previous, value });
			previousRef.current = value;
		}
	}, [onChangeRef, value]);
};

export default useValueListener;
